import classes from './FormNotActive.module.css';

interface Props {
    title: string,
    text: string
}

const FormNotActive = ({ title, text }: Props) => {
    return (
        <div className={classes.formNotActiveContainer}>
            <div>
                {title}
            </div>
            <div className={classes.formNoSelection}>
                {text}
            </div>
        </div>
    )
};

export default FormNotActive;